import React from 'react';

const ErrorPage = props => {
    const { is500Error } = props;
    return (
        <div>{ is500Error ? '500 Internal Server Error' : '404 Page Not Found' }</div>
    )
}

export default ErrorPage;
